import React from 'react'
import { Label as RebassLabel, Radio as RebassRadio } from '@rebass/forms'
import { Text } from 'rebass'
import { APPROVE_ORDER_MODE } from 'state/registrations'
import { theme } from 'theme'

interface RadioOptionProps {
    onClickRadio: any
    mode: APPROVE_ORDER_MODE
    radioMode: APPROVE_ORDER_MODE
    label: string
    description: string
}

const RadioOption: React.FC<RadioOptionProps> = ({ onClickRadio, mode, radioMode, label, description }) => {
    return (
        <>
            <RebassLabel sx={{ alignItems: 'center', color: theme.colors.mineShaft, fontSize: '14px' }}>
                <RebassRadio
                    color={'governorBay'}
                    checked={mode === radioMode}
                    onChange={(): void => onClickRadio(radioMode)}
                    size={'small'}
                />
                {label}
            </RebassLabel>

            <Text fontSize={'10px'} ml={'32px'} color={theme.colors.mineShaft}>
                {description}
            </Text>
        </>
    )
}

export default RadioOption
